import axiosCreator from '../http-common';
import { getBaseBackendApiUrl } from '../config';
import { getToken } from './authentication';


const get = async () => {
  const loginToken = await getToken();
  const axios = await axiosCreator(loginToken, true);
  return await axios.get(`${getBaseBackendApiUrl()}/profile`);
};


export default {
  get
};
